import { Button } from "react-bootstrap";
import { ChevronRightIcon } from "@heroicons/react/24/solid";
import PropTypes from "prop-types";

const ChevronButton = ({ children, ...props }) => (
	<Button {...props}>
		{children}
		<ChevronRightIcon className="i" />
	</Button>
);

ChevronButton.propTypes = {
	children: PropTypes.node.isRequired,
};

export default ChevronButton;